// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fd2b5116","977":"c255d07b"}[chunkId] + ".chunk.js";
};